import { GenericOperationState, getSelectors } from '@repo/core'
import { OtpRequiredResponse } from '@repo/user-types'
import { RootState } from '../../store/types'

const getRootPath = function (state: RootState): GenericOperationState<OtpRequiredResponse | null> {
  return state.users.addTrustDevice
}

export const addTrustDeviceDataSelector = getSelectors({
  getRootPath,
})
